import { cn } from '../../lib/format.js';

/**
 * Loading placeholders. Sized to the content they stand in for, so nothing
 * shifts when the real thing arrives — a skeleton that is the wrong height
 * causes the layout shift it was meant to prevent.
 */
export const Skeleton = ({ className, ...props }) => (
  <div
    aria-hidden="true"
    className={cn('bg-mist/70 motion-safe:animate-pulse', className)}
    {...props}
  />
);

export const SkeletonText = ({ lines = 3, className }) => (
  <div className={cn('space-y-2', className)} aria-hidden="true">
    {Array.from({ length: lines }, (_, index) => (
      <Skeleton
        key={index}
        className="h-3.5"
        style={{ width: index === lines - 1 ? '62%' : '100%' }}
      />
    ))}
  </div>
);

/** The product card's exact footprint, so a grid does not reflow as it fills. */
export const SkeletonCard = () => (
  <div className="space-y-3" aria-hidden="true">
    <Skeleton className="aspect-[4/5] w-full" />
    <Skeleton className="h-2.5 w-3/4" />
    <Skeleton className="h-4 w-full" />
    <Skeleton className="h-4 w-1/3" />
  </div>
);

export default Skeleton;
